class DealsDrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[on\\:click="/open"]');
    this.closeButton = this.querySelector('[ref="closeButton"]');

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  connectedCallback() {
    if (this.openButton) this.openButton.addEventListener('click', this.open);
    if (this.closeButton) this.closeButton.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    if (this.openButton) this.openButton.removeEventListener('click', this.open);
    if (this.closeButton) this.closeButton.removeEventListener('click', this.close);
  }

  open() {
    this.dialog?.showModal();
  }

  close() {
    this.dialog?.close();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('test') === '1') {
    // Delay reveal by 2 seconds (2000 ms)
    setTimeout(() => {
      const drawer = document.getElementById('deals-drawer-container');
      if (drawer) drawer.classList.remove('deals-hidden');
    }, 2000);
  }
});

customElements.define('deals-drawer-component', DealsDrawerComponent);